import { Component, OnInit, Input } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';

@Component({
    selector: 'app-smart-button',
    templateUrl: './smart-button.component.html',
    styleUrls: ['./smart-button.component.css'],
    standalone: false
})
export class SmartButtonComponent implements OnInit {
  progressRef: NgProgressRef;

  @Input()
  onHttpCall: 'disable' | 'hide';

  @Input()
  showSpinner = false;

  @Input()
  buttonType = 'button';

  @Input()
  buttonId = 'button';

  @Input()
  buttonClasses = 'btn btn-success';

  @Input()
  disableButton = false;

  disableOnLoading = false;
  hideOnLoading = false;
  doChangeButton: any;

  constructor(private ngProgress: NgProgress) {
    this.progressRef = this.ngProgress.ref('root');
  }

  ngOnInit() {
    if (this.onHttpCall) {
      if (this.onHttpCall === 'disable') {
        this.doChangeButton = this.doDisableButton;
      } else if (this.onHttpCall === 'hide') {
        this.doChangeButton = this.doHideButton;
      }
      this.progressRef.state.subscribe(state => {
        if (state.active) {
          this.doChangeButton(true);
        } else {
          this.doChangeButton(false);
        }
      });
    }
  }

  doHideButton(hide: boolean) {
    this.hideOnLoading = hide;
  }

  doDisableButton(disable: boolean) {
    this.disableOnLoading = disable;
  }
}
